import React, { useState } from "react";
import moment from "moment";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";

import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { isFilterApplied } from "views/pages/manage/edpOps/constant/batch-search";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { DEFAULT_FILTER_STATE } from "./";
import { InputLabelStyle } from "../../common/form-fields-mui/ASelect";

const UploadEmpDataFilters = ({
  filters,
  applyFilters,
  setFilterCount,
  filterCount,
  closeForm,
}) => {
  const [filterForm, setFilterForm] = useState(filters);

  const { status, uploadedBy, uploadDateFrom, uploadDateTo } = filterForm;

  const handleApplyFilter = () => {
    closeForm();

    const filterCount = isFilterApplied({
      ...filterForm,
    });
    setFilterCount(filterCount);
    applyFilters(filterForm);
  };

  const resetFilterForm = () => {
    closeForm();
    setFilterForm(DEFAULT_FILTER_STATE);
    applyFilters(DEFAULT_FILTER_STATE);

    setFilterCount(0);
  };

  const filterFormHandler = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Status"
            items={STATUS_DROPDOWN}
            currentValue={status}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "status");
            }}
            inputKey="status"
          />

          <AInput
            type="text"
            label="Uploaded By"
            value={uploadedBy}
            handler={(value) => {
              filterFormHandler(value, "uploadedBy");
            }}
            labelStyle={{ marginBottom: 0 }}
            placeholder="Enter uploaded by"
          />

          <div>
            <InputLabel style={InputLabelStyle}>Upload Date</InputLabel>
            <Row>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="From"
                  value={uploadDateFrom ? moment(uploadDateFrom) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "uploadDateFrom");
                  }}
                  maxDate={moment()}
                />
              </Col>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="To"
                  value={uploadDateTo ? moment(uploadDateTo) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "uploadDateTo");
                  }}
                  minDate={moment(uploadDateFrom)}
                  maxDate={moment().startOf("day")}
                  disabled={!uploadDateFrom}
                />
              </Col>
            </Row>
          </div>

          <div className="mt-3 d-flex flex-row-reverse justify-content-between">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                !uploadedBy &&
                !status.length &&
                !uploadDateFrom &&
                !uploadDateTo
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={resetFilterForm}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default UploadEmpDataFilters;

const STATUS_DROPDOWN = [
  {
    label: "Success",
    value: "Success",
  },
  {
    label: "Failed",
    value: "Failed",
  },
  {
    label: "Processing",
    value: "Processing",
  },
];
